import { CheckIcon, ChevronDownIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { cn } from "@/lib/utils";
import { EarningsPeriod } from "@/types";

const periodToLabel: Record<EarningsPeriod, string> = {
  [EarningsPeriod.ALL_YEAR]: "All year",
  [EarningsPeriod.LAST_QUARTER]: "Last quarter",
  [EarningsPeriod.THIS_QUARTER]: "This quarter",
  [EarningsPeriod.THIS_MONTH]: "This month",
};

export const EarningsPeriodDropdown = ({
  onPeriodChange,
  period,
}: {
  onPeriodChange: (period: EarningsPeriod) => void;
  period: EarningsPeriod;
}) => {
  /* Render */
  const render = () => (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outlineSecondary"
          size="sm"
          className="h-7 gap-1 rounded-full border-slate-300 bg-slate-50 px-2.5 text-xs font-medium text-slate-900"
        >
          {periodToLabel[period]}
          <ChevronDownIcon className="h-3.5 w-3.5 text-slate-500" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        {Object.values(EarningsPeriod).map((option) => (
          <DropdownMenuItem
            key={option}
            className={cn(
              "justify-between gap-2 text-xs",
              option === period && "bg-slate-50 font-medium",
            )}
            onSelect={() => {
              onPeriodChange(option);
            }}
          >
            {periodToLabel[option]}
            <CheckIcon
              className={cn(
                "h-3.5 w-3.5 shrink-0",
                option === period ? "opacity-100" : "opacity-0",
              )}
            />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );

  return render();
};
